// src/components/Header.js - FIXED VERSION
import React from 'react';
import { NavLink, Link } from 'react-router-dom';

function Header({ theme, onThemeToggle, onMobileSidebarToggle, showMobileToggle = false }) {
    return (
        <header className="main-header header-map-mode">
            <div className="header-sticky">
                <nav className="navbar navbar-expand-lg">
                    <div className="container-fluid">
                        {/* Logo */}
                        <Link className="navbar-brand" to="/">
                            <img 
                                src={theme === 'dark' ? "/assets/img/logo-white.svg" : "/assets/img/logo.svg"} 
                                alt="Sety Logo" 
                            />
                        </Link>
                        
                        {/* Desktop Navigation */}
                        <div className="collapse navbar-collapse main-menu">
                            <div className="nav-menu-wrapper">
                                <ul className="navbar-nav mr-auto" id="menu">
                                    <li className="nav-item">
                                        <NavLink className="nav-link" to="https://sety.io/">Sety</NavLink>
                                    </li>
                                    <li className="nav-item">
                                        <NavLink className="nav-link" to="https://sety.io/intel">Intel</NavLink>
                                    </li>
                                    <li className="nav-item">
                                        <NavLink className="nav-link" to="https://sety.io/developer">API</NavLink>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        {/* Right Side Actions */}
                        <div className="header-actions">
                            {/* Theme Toggle (Desktop Only) */}
                            {onThemeToggle && (
                                <button 
                                    className="theme-toggle-btn desktop-only"
                                    onClick={onThemeToggle}
                                    title={`Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`}
                                    aria-label={`Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`}
                                >
                                    <i className={`fa-solid fa-${theme === 'dark' ? 'sun' : 'moon'}`}></i>
                                </button>
                            )}
                            
                            {/* Download App Button */}
                            <a 
                                href="https://onelink.to/unm2ez" 
                                rel="noopener noreferrer"  
                                className="btn-default btn-sm-custom"
                                target="_blank"
                            >
                                <span className="btn-text">Download Sety</span>
                                <span className="btn-text-mobile">
                                    <i className="fa-solid fa-download"></i>
                                </span>
                            </a>
                            
                            {/* Mobile Sidebar Toggle (Mobile Only) */}
                            {showMobileToggle && onMobileSidebarToggle && (
                                <button 
                                    className="mobile-header-toggle mobile-only"
                                    onClick={onMobileSidebarToggle}
                                    title="Toggle sidebar"
                                    aria-label="Toggle sidebar"
                                >
                                    <i className="fa-solid fa-bars"></i>
                                    {/* <span className="badge-indicator-header">3</span> */}
                                </button>
                            )}
                        </div>
                    </div>
                </nav>
            </div>
        </header>
    );
}

export default Header;